<template>
  <div class="mine">
    <div class="proList">
      <div class="tab-bar">
        <div class="tab-radio">
          <div
            @click="menuClick(idx)"
            v-for="(item, idx) in barMenu"
            :key="idx"
            class="radio-item"
            :class="{ active: idx == menuIndex }"
          >
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div
          class="tab-page"
          :class="{ disabled: recommendList.length === 0 }"
        >
          <!-- <div class="page page-prev">上一页</div>
          <div class="page page-next">下一页</div> -->
        </div>
      </div>
      <div class="recommend-list" v-if="recommendList.length !== 0">
        <div class="recommend-item" v-for="(item,idx) in recommendList" :key="idx">
          <div class="info">
            <div class="img">
              <img :src="imgShow(item.photos)" alt="" />
            </div>
            <div class="text">
              <div class="recommend-title">{{item.comment}}</div>
              <p class="recommend-date">{{ item.create_time }}</p>
            </div>
            <div class="bottom">
              <div class="bottom-item" v-if="item.recommend_type === 1" @click="getExpress(item)">查看奖品物流</div>
              <!-- <div class="bottom-item">查看评价</div> -->
              <div @click="getInfo(item)" v-if="item.recommend_type === 0" class="bottom-item">申请领奖</div>
              <!-- <div class="bottom-item">已领奖</div> -->
              <!-- <div class="bottom-item">修改</div> -->
            </div>
          </div>
          <div v-if="false" class="refuse">
            <span>未通过理由：</span>
            <p>
              XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
            </p>
          </div>
        </div>
      </div>
      <div v-else class="not-lsit">
        <img src="@/assets/mine/null.png" alt="" />
        <p>没有更多数据了~</p>
      </div>
      <el-dialog
        :visible.sync="infoPop"
        width="40%">
        <div class="form-info">
          <div class="head">请确认领奖信息</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="ruleForm">
            <el-form-item label="联  系  人：" prop="recommend_link_name">
              <div class="form-item">
                <el-input :disabled="step === 1" v-model="ruleForm.recommend_link_name" placeholder="请输入联系人名称"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="联系电话：" prop="recommend_link_mobile">
              <div class="form-item">
                <el-input :disabled="step === 1" :maxlength="11" v-model="ruleForm.recommend_link_mobile" placeholder="请输入手机号"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="收件地址：" prop="recommend_link_addr">
              <div class="form-item">
                <el-input
                  type="textarea"
                  :rows="2"
                  :disabled="step === 1"
                  placeholder="请输入地址"
                  :maxlength="150"
                  v-model="ruleForm.recommend_link_addr">
                </el-input>
              </div>
            </el-form-item>
          </el-form>
          <div class="footer">
            <div class="f-tiem bt2" v-if="step != 0" @click="step--">修改</div>
            <div class="f-tiem bt1" @click="verify" v-if="step == 0">确认</div>
            <div class="f-tiem bt1" v-if="step != 0" @click="applyPrize">提交</div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="express"
        width="45%">
        <div class="express">
          <div class="header">温馨提示</div>
          <div class="express-text">您的奖品已经发送，物流信息如下，您可通过以下物流单号自行查询物流进度。</div>
          <div class="express-info">
            <p>物流公司: {{ info.recommend_express_name }}</p>
            <p>物流单号: {{ info.recommend_express_number }}</p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { lgisticsList,applyPrize } from "@/api/recommend.js";
import { isPhone } from '@/util/utils.js'
export default {
  name: "recommend",
  data() {
    return {
      express: false,
      step: 0,
      user_info: JSON.parse(localStorage.getItem("giftsUser")),
      classIndex: "",
      menuIndex: 0,
      infoPop: false,
      ruleForm:{
        recommend_link_name: '',
        recommend_link_mobile: '',
        recommend_link_addr: ''
      },
      rules:{
        recommend_link_name:[
          { required: true, message: '请输入联系人名称', trigger: 'blur' }
        ],
        recommend_link_mobile:[
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        recommend_link_addr:[
          { required: true, message: '请输入地址', trigger: 'blur' }
        ]
      },
      user: {},
      recommendList: [],
      info:{},
      barMenu: [
        {
          name: "审核通过",
        },
        /* {
          name: "审核不通过",
        },
        {
          name: "待审核",
        }, */
      ],
      xsList: [
        { class_name: "我要报名", id: 1 },
        { class_name: "我的推荐", id: 2 },
      ],
      deList: [
        { class_name: "我要报名", id: 3 },
        { class_name: "我的投稿", id: 4 },
        { class_name: "设计咨询", id: 5 },
      ],
    };
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("giftsUser"));
    this.init();
  },
  methods: {
    init() {
      lgisticsList({
        user_id: this.user.id,
        token: localStorage.getItem("token"),
      }).then((res) => {
        if (res.result === 0) {
          this.recommendList = [];
        } else if(res.result === 1) {
          this.recommendList = res.data
        }
      });
    },
    menuClick(idx) {
      this.menuIndex = idx;
    },
    imgShow(val) {
      const url = JSON.parse(val)
      return url[0].pic_url
    },
    getExpress(item) {
      this.info = item
      this.express = true
    },
    getInfo(item) {
      this.info = item
      this.infoPop = true
    },
    verify() {
      if (this.ruleForm.recommend_link_name === '' && this.ruleForm.recommend_link_addr === '') {
        return this.$message.error('请输入正确信息');

      }
      if (!isPhone(this.ruleForm.recommend_link_mobile)) {
        return this.$message.error('手机号格式不正确');
      }
      this.step = 1
    },
    applyPrize() {
      applyPrize({
        user_id: this.user.id,
        case_id: this.info.id,
        token: localStorage.getItem("token"),
        recommend_link_name: this.ruleForm.recommend_link_name,
        recommend_link_mobile: this.ruleForm.recommend_link_mobile,
        recommend_link_addr: this.ruleForm.recommend_link_addr
      })
      .then(res => {
        console.log(res)
        if (res.result === 1) {
          this.infoPop = false
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }
      })
    },
    userNick() {},
    selClass(id) {
      if (this.classIndex !== id) {
        this.classIndex = id;
      }
    },
  },
};
</script>
<style lang="less" scoped>
p {
  margin: 0;
}
.tab-bar {
  margin-top: 35px;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
  .tab-radio {
    display: flex;
    padding-left: 23px;
    .radio-item {
      cursor: pointer;
      position: relative;
      margin-right: 35px;
      padding-right: 35px;
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      line-height: 53px;
      &:not(:last-child)::after {
        content: "";
        right: 0;
        top: 15px;
        position: absolute;
        display: inline-block;
        width: 1px;
        height: 18px;
        background: #cccccc;
      }
      &.active {
        font-weight: 600;
        color: #4e8b46;
        span {
          display: inline-block;
          line-height: 53px;
          border-bottom: 4px solid #4e8b46;
        }
      }
    }
  }
  .tab-page {
    display: flex;
    align-items: center;
    .page {
      cursor: pointer;
      width: 100px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 12px;
      border-radius: 4px;
      border: 1px solid #b8d4b4;
      font-size: 20px;
      font-weight: 400;
      color: #999999;
      color: #4e8b46;
      &.disabled {
        cursor: not-allowed;
        color: #999;
        border: 1px solid #999999;
      }
    }
    &.disabled {
      cursor: not-allowed;
      .page {
        cursor: not-allowed;
        color: #999;
        border: 1px solid #999999;
      }
    }
  }
}
.recommend-list {
  .recommend-item {
    position: relative;
    display: flex;
    flex-direction: column;
    border: 1px solid #b8d4b4;
    border-radius: 15px;
    box-sizing: border-box;
    margin-bottom: 24.5px;
    .img {
      width: 144px;
      height: 144px;
      background: #ffffff;
      border: 1px solid #e2e2e2;
      overflow: hidden;
      border-radius: 11px;
      margin-right: 24.5px;
      display: flex;
      align-items: center;

      img {
        width: 100%;
      }
    }
    .text {
      text-align: left;
      flex: 1;
      .recommend-title {
        font-size: 24px;
        font-weight: 400;
        color: #4e8b46;
        margin-bottom: 25px;
      }
      .recommend-date {
        font-size: 18px;
        font-weight: 400;
        color: #999999;
      }
    }
    .bottom {
      display: flex;
      position: absolute;
      right: 0;
      bottom: 34px;
      .bottom-item {
        cursor: pointer;
        width: 160px;
        height: 50px;
        line-height: 50px;
        border: 1px solid #b8d4b4;
        font-size: 20px;
        font-weight: 400;
        color: #4e8b46;
        border-radius: 50px;
        margin-right: 24.5px;
      }
    }
    .info {
      position: relative;
      display: flex;
      padding: 23px;
    }
    .refuse {
      text-align: left;
      padding: 22px;
      border-top: 1px solid #ccc;
      font-size: 18px;
      font-weight: 400;
      color: #999;
      display: flex;
      span {
        color: #da0000;
      }
      p {
        flex: 1;
        word-break: break-word;
      }
    }
  }
}
.not-lsit {
  margin-top: 108px;
  font-size: 24px;
  font-weight: 400;
  color: #adadad;
  line-height: 11px;
  img {
    margin-bottom: 28px;
  }
}
.form-info{
  padding: 0 20px;
  .head{
    font-size: 48px;
    font-weight: 400;
    color: #4E8B46;
    margin-bottom: 80px;
  }
  /deep/ .el-form-item{
      margin-bottom: 45px;
    }
  .ruleForm{
    margin-bottom: 60px;
  }
  /deep/ .form-item{
    
    .el-input__inner{
      background: #F5F8F4;
      border-radius: 50px;
      font-size: 28px;
      height: 70px;
      line-height: 70px;
    }
    .el-textarea__inner{
      background: #F5F8F4;
      font-size: 28px;
    }
  }
  /deep/ .el-form-item__label {
    height: 70px;
    line-height: 70px;
    font-size: 28px;
    font-weight: 400;
    color: #666666;
  }
  .footer{
    font-size: 40px;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    .f-tiem{
      width: 294px;
      line-height: 85px;
      height: 85px;
      border-radius: 50px;
      margin: 0 18px;
      cursor: pointer;
    }
    .bt1 {
      background: #4E8B46;
    }
    .bt2 {
      color: #4E8B46;
      border: 3px solid #4E8B46;
    }
  }
}
.express{
  .header {
    font-size: 48px;
    font-weight: 400;
    color: #4E8B46;
    margin-bottom: 80px;
  }
  .express-text{
    font-size: 40px;
    font-weight: 400;
    color: #666666;
    line-height: 60px;
    margin-bottom: 67px;
  }
  .express-info{
    text-align: left;
    p {
      margin: 0;
      font-size: 40px;
      font-weight: 400;
      color: #666666;
      line-height: 65px;
    }
  }
}
</style>
